/* eslint-disable import/no-anonymous-default-export */
export default {
  translations: {
    HOME: {
      INITIAL_PAGE: "Home Page",
      UPDATED_AT: "Updated at",
      QUICK_ACCESS: "Quick Access",
      SUPORT: "Suport",
      CALL_CENTER: "Call Center",
      VEHICLE_ASSISTANCE: "Vehicle Assistance:",
      DOES_NOT_HAVE: "dont have it yet?",
      CHAT_WITH_COMMERCIAL: "Meet and chat with our commercial.",
      GENERAL_DATA: "General Data",
      SEARCH: "Search",
      COMMERCIAL: "Commercial",
      LANGUAGE: "Language",
      VEHICLE_NOT_SELECTED: "No vehicle selected",
      QUICK_CONTACT: "Quick contact",
      CONTACT_REGIONAL: "Regional",
      CONTACT_COMERCIAL: "Commercial",
      CONTACT_CENTRAL: "Emergency Central 24h",
    },
    TITLE: {
      DASHBOARD: "Management dashboard",
      FILTERS: "Filters",
      FILTER_CHARTS: "Chart filters",
      FILTER_PERIODS: "Search period",
      FILTER_GROUPS: "Vehicle group",
      MY_FLEET: "My Fleet",
      MAP: "Map",
      MAIN_GRID: "Main dashboard (Grid)",
      DETAILED_POSITIONS: "Detailed Positions",
      DRIVERS_REGISTERED: "Registered Drivers",
      DRIVER_REGISTER: "Driver Registration",
      VEHICLES: "Vehicles",
      LOGS: "Logs",
      CLIENT_SEARCH: "Client Search",
      NEARBY_VEHICLES: "Nearby Vehicles",
    },
    MENU: {
      Home: "Home",
      Rastreamento: "Tracking",
      Grupos: "Groups",
      Controle: "Control",
      Atendimento: "Service",
      Relatórios: "Reports",
      Cadastro: "Register",
      Manutenção: "Maintenance",
      Sistema: "System",
    },
    DASHBOARD_CHARTS: {
      VEHICLE_STATUS: "Vehicle Status",
      DRIVER_RANKING: "Driver Ranking",
      GREATER_CIRCULATION: "Highest Circulation",
      GREATER_IDLENESS: "Highest Idleness",
      IDLENESS_DESCRIPTION_ENGINE: "Engine On",
      IDLENESS_DESCRIPTION_IDLE: "Stopped",
      IDLENESS_DESCRIPTION_OFF: "Engine Off",
      OUTSIDE_WORK_HOURS: "Outside Work Hours",
      OUTSIDE_WORK_HOURS_DESCRIPTION: "Outside Work Hours",
      INSIDE_WORK_HOURS_DESCRIPTION: "Inside Work Hours",
      WEEKLY_CIRCULATION: "Weekly Circulation",
      SPEED_LIMIT: "Speed Limit",
      TRANSIT_FINES: "Traffic Fines",
      SPEED_ABOVE_COMPANY_LIMIT: "Speed above company limit",
      SPEED_UP_TO_20_PERCENT_ABOVE: "Speed up to 20% above road limit (moderate violation)",
      SPEED_BETWEEN_20_50_PERCENT_ABOVE: "Speed between 20% and 50% above road limit (serious violation)",
      SPEED_ABOVE_50_PERCENT: "Speed above 50% of road limit (very serious violation)",
    },
    DASHBOARD: {
      ACTIVE_VEHICLES: "Active Vehicles",
      TOTAL_ODOMETER: "Total Odometer",
      WORK_HOURS_DISTANCE: "Work Hours Distance",
      OUTSIDE_WORK_HOURS_DISTANCE: "Outside Work Hours Distance",
      ENGINE_TIME: "Engine Time",
      IDLE_TIME: "Idle Time",
      OFF_TIME: "Off Time",
      SPEED_LIMIT_DISTANCE: "Positions with Speed Limit Exceeded",
      COMPANY_SPEED_LIMIT_DISTANCE: "Positions with Company Speed Limit Exceeded",
      TOTAL_FINES: "Total Fines",
    },
    TABLE_FINES: {
      DRIVER: "Driver",
      DATE: "Date",
      VALUE: "Value (US$)",
      PLATE: "Plate",
    },
    FLEET: {
      BACK: "Back",
      MAP: "Map",
      GRID_AND_MAP: "Grid + Map",
      ACTIONS: "Actions",
      VIEW_MAP: "View map",
      OPEN_GOOGLE_MAPS: "Open Google Maps",
      BLOCK: "Block",
      ANCHOR: "Anchor",
      COMMANDS: "Commands",
      CREATE_VISIT_POINT: "Create Visit Point",
      AVAILABLE_COMMANDS: "Available commands",
      COMMAND_SENT: "Command sent",
      VEHICLE: "Vehicle",
      THIS_VEHICLE_HAS_BLOCK: "This vehicle has block",
      COMMAND_HISTORY: "Command History",
      HISTORY: "History",
      NO_DATA_FOUND: "No data found for the selected period",
    },
    IGNITION: {
      ON: "On",
      OFF: "Off",
    },
    SEARCH: {
      SEARCH: "Search",
      INITIAL_DATE_TIME: "Initial date and time",
      FINAL_DATE_TIME: "Final date and time",
      UPDATE_PAGE: "Update page",
      UPDATE: "Update",
      INITIAL_TIME: "Initial Time",
      FINAL_TIME: "Final Time",
    },
    MAINTENANCE: {
      MAINTENANCE: "Maintenance",
      REGISTER: "Register",
      REMOVE: "Remove",
      REGISTER_MAINTENANCE: "Register Maintenance",
      REMOVE_MAINTENANCE: "Remove Maintenance",
    },
    COMMANDS: {
      SEND_COMMANDS: "Send Commands",
      COMMANDS: "Commands",
      COMMAND_HISTORY: "Command History",
      ANCHOR: "Anchor",
      BLOCK: "Block",
      UNLOCK: "Unlock",
    },
    REPORTS: {
      REPORT_REQUEST: "Report Request",
      NO_DATA_IN_RESPONSE: "The response does not contain the necessary data.",
      FILTER_VALIDATION: "Filter Validation",
      ERROR_FETCHING_REPORT: "Error fetching report data",
      SELECT_VEHICLE: "Select a vehicle",
      VEHICLE_ACTIVITY_TITLE: "Vehicle Activity Report",
    },
    REPORT_COLUMNS: {
      START: "Start",
      START_LOCATION: "Start Location",
      END: "End",
      END_LOCATION: "End Location",
      TOTAL_DISTANCE: "Total Distance",
      TRAVEL_TIME: "Travel Time",
      REST_TIME: "Rest Time",
      AVG_SPEED: "Average Speed",
      MAX_SPEED: "Maximum Speed",
      DRIVER: "Driver",
      PLATE: "Plate",
      DISTANCE: "Distance",
      DAY_OF_WEEK: "Day of Week",
      DATE: "Date",
      IGNITION_ON: "Ignition On",
      ENGINE_TIME: "Engine Time",
      SAMPLES_ABOVE_SPEED: "Samples above filtered speed",
      SAMPLES_WITHIN_SPEED: "Samples within filtered speed",
      DATE_TIME: "Date/Time",
      STATUS: "Status",
      IGNITION: "Ignition",
      EVENT: "Event",
      SPEED: "Speed",
      LOCATION: "Location",
      DURATION: "Duration",
      TYPE: "Type",
      PROTOCOL: "Protocol",
      DESCRIPTION: "Description",
      OPENING_DATE: "Opening Date",
      SERVICE_DATE: "Service Date",
      CLOSING_DATE: "Closing Date",
      ATTENDANT: "Attendant",
      PROTOCOL_ID: "Protocol",
      VEHICLE_ID: "Vehicle",
      ALERT: "Alert",
      TOTAL_ROWS: "Total rows",
      TOTAL_PAGES: "Total pages",
      PAGE_NUMBER: "Page number",
      PAGE_SIZE: "Page size",
      ACCOUNT: "Account",
      USER: "User",
      MAIN_BATTERY: "Bat. Vehicle",
      BACKUP_BATTERY: "Bat. Tracker",
    },
    ALERTS: {
      TITLE: "Alerts",
      DETAILS_BUTTON: "View details",
      MODAL_TITLE: "Alert Details",
      COLUMNS: {
        PLATFORM: "Platform",
        PROTOCOL_ID: "Protocol",
        CLIENT: "Client",
        CLIENT_ID: "Client ID",
        DOCUMENT: "Document",
        EVENT_DATE: "Event Date",
        SUBTYPE: "Subtype",
        VEHICLE_ID: "Vehicle",
        PLATE: "Plate",
        LOCATION: "Location",
        STATUS: "Status",
        LAST_UPDATE: "Last Update",
        PHONE: "Phone",
        PHONE_2: "Phone 2",
      },
      FILTERS: {
        START_DATE: "Start Date",
        END_DATE: "End Date",
        SEARCH: "Search",
      },
      MODAL: {
        INTERACTIONS_TITLE: "Interactions",
        EMPTY_INTERACTIONS: "No interactions recorded.",
        NEW_INTERACTION_PLACEHOLDER: "Type a new interaction...",
        ADD_INTERACTION_BUTTON: "Add interaction",
        STATUS_LABEL: "Alert status",
        SAVE_STATUS_BUTTON: "Save status",
        INTERACTION_ADDED_SUCCESS: "Interaction added successfully.",
        INTERACTION_ADD_ERROR: "Could not add the interaction.",
        STATUS_UPDATED_SUCCESS: "Status updated successfully.",
        STATUS_UPDATE_ERROR: "Could not update the status.",
      },
    },
    PROTOCOLS: {
      TITLE: "Protocols",
      TOTAL_LABEL: "Total",
      ADD_BUTTON: "Add Protocol",
      DETAILS_BUTTON: "View details",
      COLUMNS: {
        PROTOCOL_ID: "Protocol",
        PLATFORM: "Platform",
        CLIENT: "Client",
        REGIONAL: "Regional",
        PLATE: "Plate",
        PLATE_ALIAS: "Plate Alias",
        TYPE: "Type",
        SUBTYPE: "Subtype",
        STATUS: "Status",
        EVENT_DATE: "Event Date",
        REMINDER_DATE: "Reminder",
        LAST_UPDATE: "Last Update",
      },
      FILTERS: {
        START_DATE: "Start Date",
        END_DATE: "End Date",
        PLATE: "Plate",
        CLIENT: "Client",
        PROTOCOL_ID: "Protocol",
        TYPE: "Type",
        SUBTYPE: "Subtype",
        STATUS: "Status",
        ALL: "All",
        SEARCH_BUTTON: "Filter",
      },
      MODAL: {
        CREATE_TITLE: "New Protocol",
        DETAILS_TITLE: "Protocol Details",
        VEHICLE_LABEL: "Vehicle",
        TYPE_LABEL: "Type",
        SUBTYPE_LABEL: "Subtype",
        DESCRIPTION_LABEL: "Description",
        EMAIL_LABEL: "Email",
        STATUS_LABEL: "Status",
        REMINDER_LABEL: "Reminder",
        SAVE_BUTTON: "Save",
        SAVE_STATUS_BUTTON: "Save status",
        SAVE_REMINDER_BUTTON: "Save reminder",
        CREATE_SUCCESS: "Protocol created successfully.",
        CREATE_ERROR: "Could not create the protocol.",
        DETAILS_UPDATED_SUCCESS: "Data updated successfully.",
        DETAILS_UPDATE_ERROR: "Could not update the data.",
        STATUS_UPDATED_SUCCESS: "Status updated successfully.",
        STATUS_UPDATE_ERROR: "Could not update the status.",
        REMINDER_UPDATED_SUCCESS: "Reminder updated successfully.",
        REMINDER_UPDATE_ERROR: "Could not update the reminder.",
        INTERACTIONS_TITLE: "Interactions",
        EMPTY_INTERACTIONS: "No interactions recorded.",
      },
    },
    PROTOCOL_SUMMARY: {
      TITLE: "Protocol Summary",
      TOTAL_CLIENTS_LABEL: "Total Clients",
      TOTAL_PROTOCOLS_LABEL: "Total Protocols",
      PROTOCOLS_LINK: "Protocols",
      FILTERS: {
        REGIONAL: "Regional",
      },
      COLUMNS: {
        CLIENT: "Client",
        REGIONAL: "Regional",
        EMAIL: "Master Login",
        QUANTITY: "Quantity",
        OLDEST_PROTOCOL_DATE: "Oldest Protocol",
        ADMINISTRATIVE_RESTRICTION: "Administrative Restriction",
      },
    },
    ERRORS: {
      FETCH_DATA_ERROR: "Error fetching data",
      FETCH_VEHICLES_STATUS_ERROR: "Error fetching vehicles status:",
      COMMAND_EXECUTION_ERROR: "Error executing command",
      FETCH_GROUPS_ERROR: "Error fetching groups:",
      CONFIG_NOT_FOUND: "There is no configuration for your domain. Send an email to <a href='mailto:contato@mirus.com.br'>contato@mirus.com.br</a>.",
      EMAIL_OR_PASS_INVALID: "Invalid credentials. Try again!",
      LOGIN_FAILED: "Could not log in. Check the data used.",
      EMAIL_FORMAT: "The email entered is not valid",
      CONFIRM_PASS: "Passwords must be the same",
      SEND_RECOVERY_MAILS: "Error sending password. Try again later.",
      USER_NOT_FOUND: "User not found",
      USER_NOT_SELECTED: "Select a login.",
      REQUIRED_FIELDS: "Fill in all fields",
      RESET_NOT_POSSIBLE: "Error trying to reset password, try again",
      KEY_PASS_INVALID: "Key not found, click the link received by email",
      SEARCH_ERROR: "Search error.",
      FETCH_DRIVER_LIST_ERROR: "Failed to fetch driver list",
      DELETE_DRIVER_ERROR: "Failed to delete driver",
      SAVE_DRIVER_ERROR: "Failed to save driver data",
      SAVE_LINK_ERROR: "Failed to save driver link",
      REMOVE_LINK_ERROR: "Failed to remove driver link",
    },
    COMMON: {
      CHART: "Chart",
      MIN: "Minimize",
      MAX: "Maximize",
      LOADING: "Loading",
      SEARCH: "Search",
      SAVE: "Save",
      CLOSE: "Close",
      BACK: "Back",
      ERROR: "Error",
      SUCCESS: "Success",
      ATTENTION: "Attention!",
      NAME: "Name",
      DOCUMENT: "Document",
      PLATE: "Plate",
      CPF_CNPJ: "CPF/CNPJ",
      ID: "ID",
      TYPE: "Type",
      DESCRIPTION: "Description",
      DATE: "Date",
      NO_DATA_FOUND: "No data found",
      YES: "Yes",  
      NO:  "No",   
    },
    LOGIN: {
      LOADING_SETTINGS: "Loading settings...",
      CONTACTS: "Contacts",
      SOWING_FUTURE: "Sowing Future",
      LOGIN: "Login",
      USER: "User",
      PASSWORD: "Password",
      FORGOT_PASSWORD: "Forgot your password?",
      ACCESS: "Access",
      ACCESSING: "Accessing...",
      SELECT_ACCOUNT: "Select an account linked to the login",
      ACCOUNTS: "Accounts",
      BACK: "Back",
      NEW_PASSWORD: "New Password",
      CONFIRM_PASSWORD: "Confirm Password",
      RESET_PASSWORD: "Reset Password",
      RESETTING: "Resetting...",
      RESET: "Reset",
      PASSWORD_UPDATED_SUCCESS: "Password successfully updated",
      GO_TO_LOGIN_TEXT: "Click the button to go back to the beginning and log in with the new password",
      GO_TO_LOGIN: "Go to Login",
      PASSWORD_REMINDER: "Password Reminder",
      REMINDER_SENT: "Password reminder sent to email {{email}}",
      EMAIL: "Email",
      REMEMBER_PASSWORD: "Remember Password",
      SENDING: "Sending...",
      LOADING_TEXT: "Loading...",
    },
    DRIVER: {
      NAME: "Name",
      DOCUMENT: "Document",
      FUNCTIONAL_REGISTRY: "Functional Registry",
      RE: "RE",
      IBUTTON_KEY: "iButton Key",
      LICENSE_NUMBER: "License Number",
      LICENSE_CATEGORY: "License Category",
      CNH: "CNH",
      CNH_CATEGORY: "CNH Category",
      LICENSE_EXPIRATION: "License Expiration",
      EXPIRATION: "Expiration",
      BIRTH_DATE: "Birth Date",
      BIRTH: "Birth",
      MOBILE_PHONE: "Mobile Phone",
      CELL_PHONE: "Cell Phone",
      REGISTER: "Driver Registration",
      LINKED: "Linked",
      PLATE: "PLATE",
      IMPORT_SUCCESS: "Import successfully completed.",
    },
    CLIENT: {
      SEARCH_TITLE: "Client Search",
      FILL_FIELDS_TO_FILTER: "Fill in the fields to filter the search",
      SOCIAL_NAME: "Company Name",
      TRADE_NAME: "Trade Name",
      PLATE_NICKNAME: "Plate Nickname",
      CONTRACT_STATUS: "Contract Status",
    },
    LOGS: {
      OPERATION_TYPE: "Operation Type",
      SEARCH_BUTTON: "Search",
    },
    BUTTONS: {
      SAVE: "Save",
      CLOSE: "Close",
      CANCEL: "Cancel",
      DELETE: "Delete",
      SEARCH: "Search",
      BACK: "Back",
      UPDATE: "Update",
    },
    VEHICLE_NICKNAME: {
      TITLE: "Vehicle/Nickname",
      EDIT_NICKNAME: "Edit Nickname",
      PLATE: "Plate",
      NICKNAME: "Nickname",
      DELETE: "Delete",
      CANCEL: "Cancel",
      NICKNAME_OF_VEHICLE: "the vehicle nickname",
    },
    LINKED_VEHICLES: {
      TITLE: "Linked Vehicles",
      FILTER_BY_GROUP: "Filter by Group",
      ALL_GROUPS: "All groups",
      FILTER_BY_PLATE: "Filter by Plate",
      ALL_PLATES: "All plates",
      PLATE: "Plate",
      CURRENT_GROUP: "Current Group",
      SELECT_A_GROUP: "Select a group",
      CHANGED: "changed",
      NO_VEHICLES_FOUND: "No vehicles found",
      SAVE_CHANGES: "Save changes",
      CANCEL_CHANGES: "Cancel changes",
      NOTHING_TO_SAVE: "Nothing to save",
      NO_CHANGES_TO_SAVE: "No changes to save.",
      NO_RESPONSE: "No response",
      FAILURES: "Failures",
    },
    VIEW_MAP_FILTERS: {
      TITLE: "Radar",
      GROUPS: "Groups",
      ALL_GROUPS: "All groups",
      VEHICLES: "Vehicles",
      ALL_VEHICLES: "All vehicles",
      VIEW_VISITS: "View visits",
      OPEN_VISUALIZATION: "Open visualization",
      HELP_TEXT: "Select the filters and click Open visualization to open the map in full screen",
      RECENT_QUERIES:    "Recent queries",          
      NO_RECENT_QUERIES: "No recent queries found.", 
    },
    PROFILE: {
      TITLE: "Profile",
      USER_PROFILE: "User profile",
      PHONE: "Phone",
      NAME_REQUIRED: "Name is required.",
      EMAIL_REQUIRED: "Email is required.",
      PHONE_REQUIRED: "Phone is required.",
      PHONE_INVALID: "Invalid phone. Expected format: (XX) XXXX-XXXX or (XX) 9XXXX-XXXX.",
      UPDATING: "Updating...",
      UPDATED_SUCCESS: "Profile updated successfully!",
      UPDATE_ERROR: "An error occurred while trying to update the profile!",
      AVATAR_UPDATED: "Avatar updated, will be updated after logging in again",
    },
    ACCESS_PROFILE: {
      TITLE: "Access Profile",
      CREATED_PROFILES: "Created Profiles",
      CREATE_PROFILE: "Create Profile",
      CREATE_PROFILE_PLACEHOLDER: "New profile name",
      CREATE_BUTTON: "Create",
      SELECT_PERMISSIONS: "Select the permissions for this profile:",
      SELECT_PROFILE_HINT: "Select a profile above to configure its permissions.",
      PROFILE_CREATED_SUCCESS: "Profile created successfully.",
      PROFILE_CREATE_ERROR: "Could not create the profile.",
      PERMISSION_SAVED_SUCCESS: "Permission updated successfully.",
      PERMISSION_SAVE_ERROR: "Could not update the permission.",
      PROFILE_NAME_REQUIRED: "Enter a name for the new profile.",
      LOAD_PERMISSIONS_ERROR: "Could not load this profile's permissions.",
      CATALOG_NOT_LOADED_HINT: "Open an existing profile from the list above first, to load the available options.",
      DRAFT_HINT: "Profile not created yet. Check the desired permissions and confirm below.",
      CONFIRM_CREATE_PROFILE: "Create Profile with these Permissions",
      CANCEL_SELECTION: "Cancel",
    },
    CUSTOMER: {
      TITLE: "Clients",
      SEARCH_INSTRUCTION: "Search by the CPF/CNPJ or name of the client you want to view or edit:",
      NEW_CUSTOMER: "New Client",
      SELECTED_CLIENT_LABEL: "Selected client: #{{id}} — {{name}}",
      SEARCH_HINT: "Enter a name or CPF/CNPJ and click Search.",
      FILL_SEARCH_HINT: "Enter a name or CPF/CNPJ to search.",
      SEARCH_ERROR: "Error searching for clients.",
      COLUMN_NAME: "Name",
      COLUMN_TRADE_NAME: "Trade Name",
      COLUMN_ACTIVE_CONTRACTS: "Active Contracts",
      COLUMN_REPRESENTATIVE: "Representative",
      TAB_PERSONAL_DATA: "Personal / Administrative Data",
      TAB_ADDRESS: "Address",
      TAB_CONTACTS: "Contacts List",
      TAB_NOTES: "Notes",
      TAB_SETTINGS: "Settings",
      TAB_COMMERCIAL_CONDITION: "Commercial Condition",
      TAB_LOCKED_TOOLTIP: "Save the customer to unlock this tab.",
      NEW_CUSTOMER_BLOCKED_HINT: "Fill in the personal data and save to unlock the other tabs.",
      TAB_ASSETS: "Assets",
      TAB_WIP: "Page still under development.",
      NOTES: {
        CLIENT_TITLE: "CLIENT NOTES",
        CLIENT_LABEL: "DESCRIBE THE NOTE BELOW:",
        CLIENT_PLACEHOLDER: "",
        OPERATIONAL_TITLE: "OPERATIONAL NOTES",
        OPERATIONAL_PLACEHOLDER: "",
        BILLING_TITLE: "BILLING NOTES",
        BILLING_PLACEHOLDER: "",
        BILLING_EMAILS_LABEL: "BILLING EMAIL LIST:",
        BILLING_EMAILS_PLACEHOLDER: "",
        LOADING: "Loading notes...",
        LOAD_ERROR: "Could not load the customer's notes.",
        EDIT: "EDIT",
        SAVE: "SAVE",
      },
      SETTINGS: {
        SYSTEM_TITLE: "SYSTEM",
        EVENTS_BY_PHONE: "EVENTS COMMUNICATED BY THE CALL CENTER BY PHONE (IF NOT, AN EMAIL WILL BE SENT)",
        BILLING_TITLE: "BILLING",
        BILLING_EMAIL_ALERT: "SEND EMAIL, DUE DATE AND LATE PAYMENT ALERT",
        BILLING_SMS_ALERT: "SEND SMS, DUE DATE AND LATE PAYMENT ALERT",
        AUTO_RESTRICTION: "AUTOMATIC RESTRICTION FOR NON-PAYMENT",
        AUTHORIZE_NEGATIVATION: "AUTHORIZE CREDIT BUREAU REPORTING",
        SAVE: "SAVE",
      },
      COMMERCIAL_CONDITION: {
        DUE_DAY: "DUE DAY",
        NEXT_DUE_DATE: "NEXT DUE DATE",
        CUTOFF_DAY: "CUTOFF DAY",
        PREVIOUS_CYCLE_START: "PREVIOUS CYCLE START",
        PREVIOUS_CYCLE_END: "PREVIOUS CYCLE END",
        CURRENT_CYCLE_START: "CURRENT CYCLE START",
        CURRENT_CYCLE_END: "CURRENT CYCLE END",
        BILLING_VALIDATED_BY_CLIENT: "BILLING VALIDATED BY CLIENT",
        SELECT: "Select",
        SAVE: "SAVE",
        SELECT_CONDITION_TITLE: "SELECT COMMERCIAL CONDITION",
        TYPE: "TYPE",
        PLAN_VALIDITY: "PLAN VALIDITY",
        NEXT_READJUSTMENT: "NEXT READJUSTMENT",
        CONTRACTED_SERVICE_TITLE: "CONTRACTED SERVICE",
        SUGGESTED_VALUE: "SUGGESTED VALUE",
        INSTALLMENT_TITLE: "INSTALLMENTS AND PAYMENT METHOD",
        INSTALLMENT_PLAN: "INSTALLMENTS",
        PAYMENT_METHOD: "PAYMENT METHOD",
        LOAD_CATALOGS_ERROR: "Could not load the options for this screen.",
        LOAD_FEATURES_ERROR: "Could not load the contracted services.",
        SELECT_CONDITION_HINT: "Select the Commercial Condition above to see the contracted services.",
        CONDITION_LABEL: "COMMERCIAL CONDITION",
        PAYMENT_VALUES_TITLE: "SERVICE VALUES AND PAYMENT METHODS",
        TOTAL_SERVICES: "TOTAL SERVICES",
        TOTAL_PLAN: "TOTAL PLAN",
        PERIODICITY: "PERIODICITY",
        MONTHLY_FEE: "MONTHLY FEE",
        PAYMENT_METHOD: "PAYMENT METHOD",
        INSTALLATION_VALUE_TITLE: "INSTALLATION VALUE",
        EQUIPMENT_VALUE_TITLE: "EQUIPMENT VALUE",
        VALUE: "VALUE",
        INSTALLMENTS: "INSTALLMENTS",
        FINES_TITLE: "FINES AND UNPRODUCTIVE VISITS VALUES",
        CONTRACT_TERMINATION_FINE: "CONTRACT TERMINATION FINE",
        TECHNICAL_VISIT: "TECHNICAL VISIT",
        WITHDRAWAL: "WITHDRAWAL",
        UNPRODUCTIVE_VISIT: "UNPRODUCTIVE VISIT",
        VEHICLE_EXCHANGE: "VEHICLE EXCHANGE",
        CLEAR: "CLEAR",
        REGISTERED_CONDITIONS_TITLE: "REGISTERED COMMERCIAL CONDITIONS",
        COLUMN_PLAN: "PLANS",
        COLUMN_MONTHLY_FEE: "MONTHLY FEE",
        COLUMN_CONTRACTS_QTY: "CONTRACTS QTY.",
        EDIT: "EDIT",
        DEACTIVATE: "DEACTIVATE",
      },
      CONTACTS_LIST: {
        PAGE_TITLE: "Contact Registration",
        TRUST_HINT:
          "Registered contacts must be trusted people — they are the second option Mirus will have to reach out.",
        SELECT_PLACEHOLDER: "Select",
        PHONE_LABEL: "Phone",
        EMAIL_LABEL: "Email",
        CLEAR: "Clear",
        NAME_REQUIRED: "Enter the contact's name.",
        RELATIONSHIP_REQUIRED: "This field is required.",
        PHONE_REQUIRED: "This field is required.",
        EMAIL_REQUIRED: "This field is required.",
        CONTACT_CREATED: "Contact created successfully.",
        CONTACT_UPDATED: "Contact updated successfully.",
        CONTACT_DELETED: "Contact removed successfully.",
        REGISTERED_TITLE: "Registered Contacts",
        LOAD_CONTACTS_ERROR: "Could not load this client's contacts.",
        EDIT: "Edit",
        DELETE: "Delete",
        PHONES_TITLE: "Phones",
        EMAILS_TITLE: "Emails",
        ADD_PHONES_TITLE: "Add Phones",
        ADD_EMAILS_TITLE: "Add Emails",
        COLUMN_ACTIONS: "Actions",
        COLUMN_NUMBER: "Number",
        REMOVE: "Remove",
        NO_PHONES: "No phones registered.",
        NO_EMAILS: "No emails registered.",
        EXTENSION: "ext.",
        RELATIONSHIP_UNKNOWN: "Relationship not informed",
        DOC_LABEL: "Tax ID",
        SAVE_CONTACT_ERROR: "Could not save the contact.",
        SAVE_PHONE_ERROR: "Could not save the phone.",
        DELETE_PHONE_ERROR: "Could not delete the phone.",
        SAVE_EMAIL_ERROR: "Could not save the email.",
        DELETE_EMAIL_ERROR: "Could not delete the email."},
      PERSONAL_DATA: {
        SECTION_CLIENT_DATA: "Client Data",
        CLIENT_TYPE: "Client Type",
        CLIENT_TYPE_PF: "Individual",
        CLIENT_TYPE_PJ: "Company",
        SIMPLE_TAX: "Simplified Tax Regime",
        SECTION_FINANCIAL: "Financial",
        CREDIT_ANALYSIS: "Credit Analysis",
        CREDIT_ANALYSIS_APPROVED: "Approved",
        CREDIT_ANALYSIS_REJECTED: "Rejected",
        DDA: "DDA",
        INSTALLMENT_BOOKLET: "Installment Booklet",
        SECTION_RESTRICTION: "Administrative Restriction",
        RESTRICTION_TYPE: "Restriction Type",
        SECTION_COMMERCIAL: "Commercial Owner",
        REPRESENTATIVE: "Representative",
        COMMERCIAL: "Commercial",
        CLIENT_ID: "Client ID",
        DOC: "Tax ID",
        CLIENT_NAME: "Legal Name",
        CLIENT_TRADE_NAME: "Trade Name",
        STATE_REGISTRATION: "State Registration",
        MUNICIPAL_REGISTRATION: "Municipal Registration",
        BIRTH_DATE: "Birth/Founding Date",
        EMAIL: "Email",
        PHONE: "Phone",
        CELLPHONE: "Cell Phone",
        CREATED_AT: "Created At",
        UPDATED_AT: "Last Updated",
        RESTRICTION_START_DATE: "Start Date",
        RESTRICTION_END_DATE: "End Date",
        LAST_SUSPENSION_DATE: "Last Suspension",
        SOURCE_TBD: "Data source to be defined.",
        LOAD_PLANS_ERROR: "Could not load the service plans.",
        LOAD_CLIENT_ERROR: "Could not load the client data.",
        LOAD_RESTRICTIONS_ERROR: "Could not load the restriction types.",
        LOAD_REPRESENTATIVES_ERROR: "Could not load the representatives.",
        LOAD_SALESPEOPLE_ERROR: "Could not load the salespeople.",
        BILLING_BUTTON: "Billing",
        REQUIRED_FIELDS_ERROR: "Fill in the required fields (Name and Tax ID) before saving.",
        CLIENT_NAME_REQUIRED: "Name is required.",
       DOC_REQUIRED: "Tax ID is required.",
        REQUIRED_FIELDS_HINT: "Required fields",
        UPDATING: "Saving...",
        UPDATED_SUCCESS: "Client saved successfully!",
        UPDATE_ERROR: "An error occurred while saving the client!",
      },
      ASSETS: {
        PAYER_HINT: "* To be able to change the commercial condition, select the paying client.",
        SEARCH_PAYER_TITLE: "Search Paying Client",
        CLEAR: "Clear",
        STATUS_LABEL: "Select the Status",
        SELECT_PLACEHOLDER: "Select",
        TOTAL_CONTRACTS: "Total Contracts",
        SEARCH_CONTRACTS: "Search Contracts",
        RESULTS_TITLE: "Selected Client's Contracts",
        SEARCH_HINT: "Enter the filters and click Search Contracts.",
        COLUMN_CONTRACT: "Contract",
        COLUMN_PLATE: "Plate",
        COLUMN_SERIAL: "Serial",
        COLUMN_REGISTERED_AT: "Registration Date",
        COLUMN_ACTIVATED_AT: "Activation Date",
        COLUMN_LAST_CHANGE_AT: "Last Change",
        COLUMN_STATUS: "Status",
        COLUMN_COMMERCIAL_CONDITION: "Commercial Condition",
        COLUMN_ACTIONS: "Actions",
        DETAILS_BUTTON: "Details",
        DETAILS_TITLE: "Contract Details",
        DETAILS_WIP: "Contract {{contractId}} details screen not implemented yet."
      },
      ADDRESS: {
        MAIN_TITLE: "MAIN ADDRESS",
        BILLING_TITLE: "BILLING ADDRESS",
        SAME_AS_MAIN: "Same as main address.",
        CEP: "ZIP CODE",
        STREET: "ADDRESS",
        NUMBER: "NUMBER",
        NEIGHBORHOOD: "NEIGHBORHOOD",
        COMPLEMENT: "COMPLEMENT",
        UF: "STATE",
        CITY: "CITY",
        INVALID_CEP: "Enter a valid ZIP code.",
        CEP_NOT_FOUND: "ZIP code not found.",
        CEP_SEARCH_ERROR: "Error searching ZIP code.",
        CEP_FOUND: "ZIP code found.",
        LOAD_ERROR: "Could not load the customer's address.",
        SAVING: "Saving...",
        SAVE_ERROR: "Could not save the address.",
        SAVED_SUCCESS: "Address saved successfully!",
      },
    },
    DRIVER_PROFILE: {
      VEHICLES: "Vehicles",
    },
    LOGS_CONTROL: {
      ID: "Id",
      TYPE: "Type",
      DESCRIPTION: "Description",
      DATE: "Date",
    },
    GROUP_USERS: {
      TITLE: "Bind users to groups",
      GROUPS: "Groups",
      SELECT_ALL: "Select All",
      REMOVE_ALL: "Remove All",
      USER: "User",
      EMAIL: "Email",
      BIND: "Bind",
      SAVE: "Save",
      SAVING: "Saving...",
      LOADING_USERS: "Loading group users...",
      PROCESSING: "Processing...",
      SELECT_GROUP_MESSAGE: "Select a group to view users.",
      NO_USERS_FOUND: "No users found in this group.",
      NO_MARKER_SELECTED: "No marker selected.",
      NO_GROUP_SELECTED: "No group selected.",
      CHANGES_SAVED: "change(s) saved successfully.",
      SAVE_ERROR: "Could not save changes.",
      REQUEST_ERROR: "Request failed.",
    },
    TRANSPORT_CLIENTS: {
      PAGE_TITLE: "Clients",
      LIST_TITLE: "Registered companies",
      ADD_NEW: "Add",
      EDIT_TITLE: "Edit Company",
      NEW_TITLE: "New Company",
      COMPANY_NAME: "Company Name",
      CNPJ: "Tax ID",
      PHONE_1: "Main Phone",
      PHONE_2: "Secondary Phone",
      EMAIL: "Email",
      SEND_NON_CONFORMITY_EMAIL: "Send non-conformity report when the line is completed.",
      SEND_CONFORMITY_EMAIL: "Include conformities in the sent report.",
      SEND_COPY: "Receive a copy of the report sent to the client.",
      SAVE: "Save",
      CANCEL: "Cancel",
      ACTIONS: "Actions",
      EDIT: "Edit",
      DELETE: "Delete",
      COMPANY_NAME_REQUIRED: "Company name is required.",
      CNPJ_REQUIRED: "Tax ID is required.",
      CNPJ_INVALID: "Invalid Tax ID.",
      EMAIL_REQUIRED: "Email is required.",
      EMAIL_INVALID: "Invalid email.",
      LOGIN: "Login",
      LAST_ACCESS: "Last Access",
      NO_RECORDS_FOUND: "No records found",
      LOAD_ERROR: "Error loading companies",
      SAVE_ERROR: "An error occurred while saving the company.",
      SAVE_SUCCESS_NEW: "Company successfully registered!",
      SAVE_SUCCESS_EDIT: "Company successfully updated!",
      DELETE_SUCCESS: "Company successfully deleted!",
      DELETE_ERROR: "An error occurred while deleting the company.",
      LAST_ACCESS_DATE: "Last access date",
    },
    TRANSPORT_PATHS: {
      PAGE_TITLE: "Paths",
      LIST_TITLE: "Registered paths",
      ADD_NEW: "Add",
      EDIT_TITLE: "Edit Path",
      NEW_TITLE: "New Path",
      COMPANY: "Company Name",
      SELECT_COMPANY: "Select a company",
      SELECT_COMPANY_MESSAGE: "Select a company to view its paths.",
      NAME: "Path Name",
      PURPOSE: "Purpose",
      SELECT_PURPOSE: "Select",
      PURPOSE_ENTRY: "Inbound",
      PURPOSE_EXIT: "Outbound",
      DAYS: "Select the path's operating days",
      SUNDAY: "Sunday",
      MONDAY: "Monday",
      TUESDAY: "Tuesday",
      WEDNESDAY: "Wednesday",
      THURSDAY: "Thursday",
      FRIDAY: "Friday",
      SATURDAY: "Saturday",
      START_TIME: "Start Time",
      END_TIME: "End Time",
      GROUP: "Group",
      ALL_GROUPS: "All",
      VEHICLE: "Vehicle",
      SELECT_VEHICLE: "Select",
      SAVE: "Save",
      CANCEL: "Cancel",
      CLEAR: "Clear",
      ACTIONS: "Actions",
      EDIT: "Edit",
      DELETE: "Delete",
      LINE_COLUMN: "Path",
      START_COLUMN: "Start",
      END_COLUMN: "End",
      WEEK_COLUMN: "Week",
      VEHICLE_COLUMN: "Vehicle",
      NAME_REQUIRED: "Path name is required.",
      PURPOSE_REQUIRED: "Purpose is required.",
      VEHICLE_REQUIRED: "Vehicle is required.",
      NO_RECORDS_FOUND: "No paths found",
      LOAD_ERROR: "Error loading paths",
      SAVE_ERROR: "An error occurred while saving the path.",
      SAVE_SUCCESS_NEW: "Path successfully registered!",
      SAVE_SUCCESS_EDIT: "Path successfully updated!",
      DELETE_SUCCESS: "Path successfully deleted!",
      DELETE_ERROR: "An error occurred while deleting the path.",
      REPROCESS_DAILY: "Reprocess Daily Records",
      REPROCESS_SUMMARY: "Reprocess Summary",
      START_DATE: "Start Date",
      END_DATE: "End Date",
      EXPORT_FILE: "Export File",
      FEATURE_NOT_AVAILABLE: "Feature not available yet.",
    },
    NOTIFICATIONS_CONFIG: {
      PAGE_TITLE: "Notifications",
      LIST_TITLE: "Notification Settings",
      SELECT_ALL: "Select All",
      DESELECT_ALL: "Deselect All",
      NO_RECORDS_FOUND: "No notifications found",
      LOAD_ERROR: "Error loading notifications",
      SAVE_ERROR: "An error occurred while updating the notification.",
      SAVE_SUCCESS: "Notification successfully updated!",
    },
    GROUPS: {
      PAGE_TITLE: "Group Registration",
      LIST_TITLE: "Group List",
      REGISTER_TITLE: "Group Data",
      DELETE_ERROR_TITLE: "Error deleting",
      DELETE_ERROR_TEXT: "Group in use, deletion not allowed.",
      FILTERS: "Filters",
      SELECT_GROUP: "Select a group",
      CURRENT_GROUP: "Current Group",
      NO_VEHICLES_FOUND: "No vehicles found",
      ACTION_CONFIRMED: "Action confirmed!",
      CONFIRM: "Confirm",
      DESCRIPTION: "Description",
      DEFAULT: "Default",
      DEFINE_DEFAULT: "Define Default",
      DELETE: "Delete",
      SELECT_GROUP_REQUIRED: "Select a destination group to move the vehicles before deleting.",
      MOVE_VEHICLES_ERROR: "Could not move the vehicles to the new group. Deletion was cancelled.",
    },
    MODAL_VISITS: {
      TITLE: "Nearby Vehicles",
      GRID: "Grid",
      MAP: "Map",
      PLATE: "Plate",
      MODEL: "Model",
      DISTANCE: "Distance (m)",
      LAST_POSITION: "Last Position",
      EXPORT_PDF: "Export PDF",
      EXPORT_EXCEL: "Export Excel",
      NO_VEHICLES_NEARBY: "No nearby vehicles found",
    },
    VISIT_CONTROL: {
      TITLE: "Visit Control",
      NEW_VISIT: "New Visit",
      EDIT_VISIT: "Edit Visit",
      VISIT_NAME: "Visit Name",
      ADDRESS: "Address",
      RADIUS: "Radius (m)",
      CATEGORY: "Category",
      SAVE_SUCCESS: "Visit saved successfully",
      DELETE_SUCCESS: "Visit deleted successfully",
    },
    VISIT_POINTS: {
      TITLE: "Visit Points",
      POINT_NAME: "Point Name",
      COORDINATES: "Coordinates",
      CREATED_AT: "Created At",
      VIEW_MARKER: "View marker",
      EDIT_MARKER: "Edit marker",
      CREATE_MARKER: "Create marker by:",
      ADDRESS: "Address",
      COORDINATE: "Coordinate",
      NAME: "Name",
      RADIUS: "Radius (m)",
      RADIUS_SELECT: "-- Radius --",
      ADDRESS_PLACEHOLDER: "Enter address...",
      LATITUDE: "Latitude",
      LONGITUDE: "Longitude",
      EDIT: "Edit",
      DISPLAY: "Display",
      INSERT: "Insert",
      UPDATE: "Update",
      MARKER_PLACEHOLDER: "Marker",
      SELECT_ADDRESS: "Select an address",
      EDIT_COORDINATE: "Edit Coordinate",
      PROCESSING: "Processing...",
      CANCEL: "Cancel",
      SAVE: "Save",
      SAVING: "Saving...",
      CONFIRM_DELETE: "Confirm deletion",
      DELETE_MESSAGE: "Do you really want to delete the address",
      DELETE: "Delete",
      VISIT_POINTS: "Visit points",
      MAP: "Map",
      MAP_HEADER: "Map",
    },
    REGISTER_VEHICLE: {
      TITLE: "Vehicle Registration",
      VEHICLE_DATA: "Vehicle Data",
      LICENSE_PLATE: "License Plate",
      CHASSIS: "Chassis",
      MODEL: "Model",
      YEAR: "Year",
      COLOR: "Color",
      SAVE_SUCCESS: "Vehicle saved successfully",
    },
    CONTROL_POINTS: {
      TITLE: "Control Points",
      NEW_POINT: "New Point",
      POINT_NAME: "Point Name",
      DESCRIPTION: "Description",
      TYPE: "Type",
    },
    VEHICLES_CONFIG: {
      TITLE: "Vehicle Configurations",
      GENERAL: "General",
      NOTIFICATIONS: "Notifications",
      SPEED_LIMIT: "Speed Limit",
      FUEL: "Fuel",
      MAINTENANCE: "Maintenance",
    },
    RISK_AREA: {
      TITLE: "Risk Areas",
      NEW_AREA: "New Area",
      AREA_NAME: "Area Name",
      DANGER_LEVEL: "Danger Level",
      LOW: "Low",
      MEDIUM: "Medium",
      HIGH: "High",
      CRITICAL: "Critical",
      GRID: "Grid",
      MAP: "Map",
      DESCRIPTION: "Description",
      LOCATION: "Location",
      ACTIONS: "Actions",
      EDIT: "Edit",
      DELETE: "Delete",
      VIEW: "View",
      SEARCH_ADDRESS: "Search address",
      DRAW_POLYGON: "Draw polygon",
      EDIT_MODE: "Edit mode on",
      SAVE_AREA: "Save Area",
      UPDATE_AREA: "Update Area",
      CLEAR: "Clear",
      SAVE: "Save",
      SAVING: "Saving...",
      CANCEL: "Cancel",
      CLOSE: "Close",
      CONFIRM_DELETE: "Confirm deletion",
      DELETE_MESSAGE: "Do you really want to delete the area",
      AREA_DESCRIPTION: "Area description",
      POLYGON_DESCRIPTION: "Polygon description",
      BIND_VEHICLES: "Bind Vehicles",
      RISK_AREAS: "Risk areas",
      POLYGON_FENCES: "Polygon Fences",
      ADDRESS_PLACEHOLDER: "Enter city, neighborhood or address…",
      SEARCH: "Search",
    },
    ELETRONIC_FENCES: {
      TITLE: "Electronic Fences",
      NEW_FENCE: "New Fence",
      CREATE_FENCE: "Create fence",
      EDIT_FENCE: "Edit fence",
      FENCE_NAME: "Fence Name",
      FENCE_TYPE: "Fence Type",
      CIRCULAR: "Circular",
      POLYGONAL: "Polygonal",
      ACTIVE: "Active",
      INACTIVE: "Inactive",
      ALERT_ON_ENTRY: "Alert on Entry",
      ALERT_ON_EXIT: "Alert on Exit",
      GRID: "Grid",
      MAP: "Map",
      DESCRIPTION: "Description",
      LOCATION: "Location",
      RADIUS: "Radius (m)",
      ACTIONS: "Actions",
      EDIT: "Edit",
      DELETE: "Delete",
      VIEW: "View",
      ORIGIN: "Origin",
      DESTINATION: "Destination",
      BUFFER_WIDTH: "Fence width (m)",
      CALCULATE_ROUTE: "Calculate route",
      APPLY_BUFFER: "Apply",
      SAVE: "Save",
      SAVING: "Saving...",
      CANCEL: "Cancel",
      CLOSE: "Close",
      CONFIRM_DELETE: "Confirm deletion",
      DELETE_MESSAGE: "Do you really want to delete the fence",
      // eslint-disable-next-line no-dupe-keys
      EDIT_FENCE: "Edit Fence",
      VIEW_FENCE: "View Fence",
      // eslint-disable-next-line no-dupe-keys
      CREATE_FENCE: "Create Electronic Fence",
      BIND_VEHICLES: "Bind Vehicles",
      BIND_GROUPS: "Bind Groups",
      VEHICLE_GROUPS: "Vehicle Groups",
      SELECT_GROUP: "Select a group",
      VEHICLES: "Vehicles",
      SELECT_VEHICLES: "Select vehicles",
      SAVE_BINDINGS: "Save Bindings",
      ORIGIN_FENCE: "Fence origin",
      DESTINATION_FENCE: "Fence destination",
      ORIGIN_FENCE_EDITED: "Edited fence origin",
      DESTINATION_FENCE_EDITED: "Edited fence destination",
      ERROR_ROUTE_DRAW: "Error plotting route",
      ERROR_LOAD_FENCE_DATA: "Error loading fence data. Please try again.",
      FENCE_DELETED_SUCCESS: "Fence deleted successfully.",
      FENCE_DELETE_FAIL: "Could not delete the fence.",
      UNEXPECTED_DELETE_FAILURE: "Unexpected failure while deleting.",
      REVERSE_GEOCODING_ERROR: "Reverse geocoding error",
      PLEASE_ENTER_FENCE_DESCRIPTION: "Please enter a description for the electronic fence",
      INVALID_POLYGON_TITLE: "Invalid polygon",
      INVALID_POLYGON_MIN_POINTS: "The polygon must have at least 3 points",
      SAVED_SUCCESS: "Saved successfully",
      ERROR_UPDATE_FENCE: "Error updating electronic fence. Please try again.",
      INCOMPLETE_POINTS_TITLE: "Incomplete points",
      DEFINE_ORIGIN_DESTINATION_BEFORE_SAVE: "Set origin and destination before saving",
      ROUTE_NOT_CALCULATED_TITLE: "Route not calculated",
      CALCULATE_ROUTE_BEFORE_SAVE: "Calculate the route before saving",
      ERROR_SAVE_FENCE: "Error saving electronic fence. Please try again.",
      GENERATED_BY_MAP: "Electronic fence generated by map",
      FENCE_UPDATED_TITLE: "Fence Updated",
      FENCE_UPDATED_SUCCESS: "Electronic fence updated successfully",
      ERROR_UPDATE_FENCE_SHORT: "Error updating electronic fence",
      ERROR_LOADING_FENCES: "Error loading fences. Please try again.",
      FENCE_NOT_FOUND: "Fence not found",
      ERROR_LOADING_EDIT_DATA: "Error loading edit data",
      DELETE_WITHOUT_LINKED_VEHICLE_MSG: "To delete a fence, it cannot have any linked vehicle",
      NO_VEHICLES_FOUND_FOR_POINT: "No vehicles found for this point.",
      AREA_DESCRIPTION_PLACEHOLDER: "E.g.: Risk area - North Zone",
      EDITING: "Editing",
      CLICK_MAP_DEFINE: "Set by clicking on map:",
      ORIGIN_INPUT_LABEL: "Origin (type/select or click on map)",
      DESTINATION_INPUT_LABEL: "Destination (type/select or click on map)",
      ORIGIN_PLACEHOLDER: "Av. Paulista, 1000, São Paulo…",
      DESTINATION_PLACEHOLDER: "Praça da Sé, São Paulo…",
      SWAP: "Swap",
      CLEAR: "Clear",
      ORIGINAL_ROUTE: "Original route",
      ELECTRONIC_FENCE: "Electronic fence",
      ERROR_CALCULATE_ROUTE: "Error calculating route. Check if origin and destination points are defined.",
      LOADING_FENCES: "Loading electronic fences...",
      BIND_UNBIND: "Bind / Unbind",
      VIEW_ON_MAP: "View on map",
    },
    ROUTING: {
      TITLE: "Routing",
      VIEW_MAP: "View map",
      COPY_LINK: "Copy link",
      GENERATE_FENCE: "Generate Electronic Fence",
      ADD_POINT: "Add point",
      TYPE_ADDRESS: "Address",
      TYPE_COORDINATE: "Coordinate",
      TYPE_VISIT_POINT: "Visit Point",
      LATITUDE: "Latitude",
      LONGITUDE: "Longitude",
      LOADING_VISIT_POINTS: "Loading visit points...",
      SELECT_VISIT_POINT: "Select a visit point",
      ERROR_CALCULATE_ROUTE: "Error calculating route. Check if origin and destination points are defined.",
      LINK_COPIED: "Link copied to clipboard",
      LINK_COPY_ERROR: "Error copying link",
      MAX_POINTS_REACHED: "Maximum number of points reached (25)",
    },
    VEHICLE_NEAREST: {
      TITLE: "Nearest Vehicle",
      SELECT_METHOD: "Select how you want to find the nearest vehicle",
      ADDRESS: "Address",
      VEHICLE: "Vehicle",
      VISIT_POINT: "Visit Point",
      ENTER_ADDRESS: "Enter the address you want",
      LOCATE_ADDRESS: "Locate address",
      NO_ADDRESS_FOUND: "No information found for the given address",
      SELECT_VEHICLE_DISTANCE: "Select the vehicle you want to calculate the distance from point",
      GROUPS: "Groups",
      ALL_GROUPS: "All groups",
      VEHICLES: "Vehicles",
      ALL_VEHICLES: "All vehicles",
      FILTER: "Filter",
      GROUP: "Group",
      DATE_TIME: "Date/Time",
      NO_VEHICLE_INFO: "No information found for user vehicles",
      SELECT_POINT: "Select the point where you want to locate the nearest vehicle",
      SEARCH_RADIUS: "Search Radius",
      FOUND_VEHICLES: "Found Vehicles",
      NO_VEHICLES: "No vehicles found in the area",
    },
    FILTERS_COMPONENT: {
      MINIMUM_DURATION: "Minimum Duration",
      TYPE: "Type",
      BOTH: "Both",
      VISIT_POINT: "Visit Point",
      STOP_POINT: "Stop Point",
      ALL: "All",
      COMPANY_SPEED_ONLY: "Company speed only",
      ROAD_SPEED_MODERATE: "Above road speed - moderate violation",
      ROAD_SPEED_SERIOUS: "Above road speed - serious violation",
      ROAD_SPEED_VERY_SERIOUS: "Above road speed - very serious violation",
      ROAD_SPEED_ALL: "Above road speed - all violations",
      VEHICLE: "Vehicle",
      ALL_VEHICLES: "All vehicles",
      DRIVERS: "Drivers",
      ALL_DRIVERS: "All drivers",
      START: "Start",
      END: "End",
      START_DATE_TIME: "Start date and time",
      END_DATE_TIME: "End date and time",
      REPORTS: "Reports",
      DISPLAY: "Display",
      EXCEL: "Excel",
      PDF: "PDF",
    },
    CLIENT_DETAILS: {
      PAGE_TITLE: "Client Details",
      VIEW_CLIENT: "View Client",
      FANTASY_NAME: "Fantasy Name",
      SHORT_NAME: "Short Name",
      FULL_NAME: "Full Name",
      SOCIAL_NAME: "Company Name",
      IDENTIFICATION: "Identification",
      ADDRESS: "Address",
      ADDRESS_2: "Address 2",
      COMPANY_REGISTRATION: "Company Registration",
      PHONE_1: "Phone 1",
      PHONE_2: "Phone 2",
      OBSERVATION: "Observation",
      NUMBER: "Number",
      NEIGHBORHOOD: "Neighborhood",
      COMPLEMENT: "Complement",
      STATE: "State",
      CITY: "City",
      ZIP_CODE: "ZIP Code",
      CNPJ: "CNPJ",
      STATE_REGISTRATION: "State Registration",
      MUNICIPAL_REGISTRATION: "Municipal Registration",
      SIMPLE_TAX_OPTANT: "Simple Tax Optant",
      PUBLIC_COMPANY: "Public Company",
      YES: "Yes",
      NO: "No",
      PERSON_TYPE: "Person Type",
      INDIVIDUAL: "Individual",
      COMPANY: "Company",
    },
    TABLE: {
      DEFAULT: "Default",
      ACTIONS: "Actions",
      FILTER: "Filter",
      GLOBAL_SEARCH: "Global search",
      LOAD_DATA_ERROR: "Error loading data",
      SELECT_OPTION: "Select an option to display data.",
    },
    USER_NAV: {
      USER_PROFILE: "User Profile",
      CHANGE_PASSWORD: "Change Password",
      CLIENT_USERS: "Client Users",
      COMPANY: "Company",
      NOTIFICATIONS: "Notifications",
      FILL_BOTH_FIELDS: "Fill both fields",
      PASSWORDS_MUST_MATCH: "Both passwords must match",
      PASSWORD_CHANGED: "Password changed",
      PASSWORD_CHANGED_SUCCESS: "Password changed successfully",
      PASSWORD_CHANGE_ERROR: "Error changing password, please try again later",
    },
    DELETE_MODAL: {
      CONFIRM_DELETE: "Do you really want to delete",
      OK: "Ok",
    },
    MESSAGE_MODAL: {
      WARNING: "Warning!",
    },
    INFO_WINDOW: {
      VEHICLE: "Vehicle",
      MODEL: "Model",
      MANUFACTURER: "Manufacturer",
      YEAR: "Year",
      CATEGORY: "Category",
      ADDRESS: "Address",
      STATUS: "Status",
      EVENT: "Event",
      DRIVER: "Driver",
      IGNITION_BATTERY: "Ignition (Battery)",
      GROUP: "Group",
      SPEED: "Speed",
      ODOMETER: "Odometer",
      TIME_ELAPSED: "Time Elapsed",
      TRACKER_BATTERY: "Tracker Battery",
      VEHICLE_BATTERY: "Vehicle Battery",
    },
    MAINTENANCES: {
      MAINTENANCE_ITEM: {
        DESCRIPTION: "Add the item you want to track usage of",
        INPUT_PLACEHOLDER: "Type the item name",
        BTN_SAVE: "Save New",
        BTN_CANCEL: "Cancel",
        FIELD_TABLE_ITEM: "Item",
        FIELD_TABLE_EDIT: "Edit",
        FIELD_TABLE_DELETE: "Delete",
      },
      SCHEDULING: {
        DESCRIPTION: "Add the item you want to schedule for maintenance",
        ITEMS: "Items",
        SELECT_ITEM: "Select an item",
        SCHEDULING: "Scheduling",
        SINGLE_ENTRY: "Single Entry",
        DATE: "Date",
        KM: "Km",
        OR: "Or",
        SELECT: "Select",
        DAYS: "days",
        MAINTENANCE_COST: "Maintenance Cost",
        UPDATE: "Update",
        SAVE: "Save",
        SAVING: "Saving...",
        CLEAR: "Clear",
        VEHICLE: "Vehicle",
        ITEM: "Item",
        TIME_DAYS: "Time (days)",
        ADDED: "Added",
        ACTIONS: "Actions",
        NO_ITEMS_SCHEDULED: "No items scheduled",
      },
      COMPLETED: {
        TITLE: "Completed Maintenance",
        DESCRIPTION: "Select the vehicle and enter the period",
        UNTIL: "Until",
        SEARCH: "Search",
      },
      PENDINGS: {
        TITLE: "Pending Maintenance",
        DESCRIPTION: "Select the vehicle and enter the period",
        STATUS: "Status",
        SELECT_STATUS: "Select status",
        STATUS_SELECT: "Select",
        STATUS_UP_TO_DATE: "Up to date",
        STATUS_PROVIDE: "Provide",
        STATUS_DELAYED: "Delayed",
        STATUS_COMPLETED: "Completed",
        SEARCH: "Search",
      },
      REGISTER_KM: {
        TITLE: "Odometer Registration",
        DESCRIPTION: "To register KM, select the vehicle and fill in the information",
        REGISTER: "Register",
        SEARCH_FILTER: "Search / Filter",
        SEARCH: "Search",
      },
      SHIPPING: {
        TITLE: "Item Tracking",
        DESCRIPTION: "View all registered items, you can filter by vehicle, item and/or status",
        ITEMS: "Items",
        SELECT_ITEM: "Select an item",
        STATUS: "Status",
        SELECT_STATUS: "Select status",
        SEARCH: "Search",
        VEHICLE_ITEMS: "Vehicle Items",
        VEHICLE: "Vehicle",
        ITEM: "Item",
        HOURS: "Hours",
        EDIT: "Edit",
        DELETE: "Delete",
        CONFIRM_DELETE: "Confirm deletion",
        CONFIRM_DELETE_MESSAGE: "Are you sure you want to delete this item?",
        CANCEL: "Cancel",
      }
    },
    PREVIEWS: {
      CREATE_LICENSED: {
        PAGE_TITLE: "Create Licensee",
        PAGE_SUBTITLE: "Configure visual identity and parameters",
        SAVE: "Save",
        SAVING: "Saving...",
        SAVED: "Saved!",
        TABS: {
          LICENSEE: "Licensee",
          IMAGES: "Images",
          GENERAL_COLORS: "General Colors",
          MENU: "Menu",
          CARDS: "Cards",
          FILTERS: "Filters",
          TABLES: "Tables",
          BUTTONS: "Buttons",
        },
        THEME: {
          LIGHT: "Light",
          DARK: "Dark",
        },
        LICENSEE: {
          SECTION_TITLE: "Licensee Data",
          LICENSED_ID_LABEL: "Licensee ID",
          LICENSED_ID_PLACEHOLDER: "Ex: 4939",
          PLATFORM_NAME_LABEL: "Platform Name",
          PLATFORM_NAME_PLACEHOLDER: "Ex: Olhar Fixo v3",
          PHRASE_LABEL: "Phrase / Slogan",
          PHRASE_PLACEHOLDER: "Ex: Helping your business grow",
          DOMAIN_LABEL: "Domain",
          PHONE_LABEL: "Phone",
          CENTRAL_PHONE_LABEL: "Central Phone",
          IOS_LINK_LABEL: "iOS App Store Link",
          ANDROID_LINK_LABEL: "Android Play Store Link",
          LANGUAGE_LABEL: "Language",
          LANG_PT_BR: "Português (BR)",
          LANG_EN_US: "English (US)",
          LANG_ES: "Español",
        },
        IMAGES: {
          SECTION_TITLE: "System Images",
          COMPANY_LOGO_LABEL: "Company Logo",
          COMPANY_LOGO_DESC: "Displayed on login and navbar",
          HOME_SCREEN_LABEL: "Home Screen Image",
          HOME_SCREEN_DESC: "Outdoor image on login screen",
          CONDENSED_MENU_LABEL: "Condensed Menu",
          CONDENSED_MENU_DESC: "Icon for collapsed menu",
          FAVICON_LABEL: "Favicon",
          FAVICON_DESC: "Browser tab icon",
        },
        COLORS: {
          SECTION_TITLE: "General Colors",
          THEME: "Theme",
          BACKGROUNDS: "Backgrounds",
          TEXTS: "Texts",
          BORDERS: "Borders",
          STATUS: "Status",
        },
        PREVIEW: {
          REAL_TIME: "Real-time preview",
          GENERAL: "General",
          LOGIN: "Login",
          BOTH: "Both",
          LOGIN_SCREEN: "Login Screen",
          GENERAL_PREVIEW: "General Preview",
        },
        ERRORS: {
          REQUIRED_FIELDS: "Fill in required fields: licensedId, domain and platformName",
        },
      },
    },

    TOOLTIPS: {
      DASHBOARD:
        "Overview of all fleet data, including vehicle status, KPIs, and analysis charts.",
      // Dashboard - Cards KPI
      DASHBOARD_CARDS_ACTIVE_VEHICLES:
        "Indicates the number of tracked vehicles, according to the selected group filter.",
      DASHBOARD_CARDS_TOTAL_ODOMETER:
        "Indicates the sum of the odometers of tracked vehicles, according to the selected group and period filters.",
      DASHBOARD_CARDS_KM_BUSINESS_HOURS:
        "Indicates the sum of the odometers of tracked vehicles that circulated within business hours (default: Monday to Friday, 8 a.m. to 6 p.m.), according to the selected group and period filters.",
      DASHBOARD_CARDS_KM_OUTSIDE_HOURS:
        "Indicates the sum of the odometers of vehicles that circulated outside business hours (default: before 8 a.m. or after 6 p.m. on business days, any time on weekends), according to the selected group and period filters.",
      DASHBOARD_CARDS_ENGINE_TIME:
        "Indicates the sum of the time vehicles were on and moving, according to the selected group and period filters.",
      DASHBOARD_CARDS_IDLE_TIME:
        "Indicates the sum of the time vehicles were on but stopped (considered from 2 minutes in the same place), according to the selected group and period filters.",
      DASHBOARD_CARDS_OFF_TIME:
        "Indicates the sum of the time vehicles were turned off, according to the selected group and period filters.",
      DASHBOARD_CARDS_SPEED_LIMIT_DISTANCE:
        "Indicates the sum of the positions traveled above the legal road speed limit, according to the selected group and period filters.",
      DASHBOARD_CARDS_COMPANY_SPEED_LIMIT_DISTANCE:
        "Indicates the sum of the positions traveled above the speed defined by the company (urban default: 80 km/h, highway default: 120 km/h), according to the selected group and period filters.",

      // Dashboard - Charts
      DASHBOARD_CHARTS_VEHICLE_STATUS:
        "Shows the activity of fleet vehicles (on, off, stopped, moving) and highlights tracking issues such as GPS problems, positioning delays, and communication failures with the tracker.",
      DASHBOARD_CHARTS_QUICK_CONTACTS:
        "Provides quick access to Movyx contact options, including regional branch, Movyx consultant, and 24/7 call center.",
      DASHBOARD_CHARTS_DRIVERS_RANKING:
        "Driver or vehicle ranking that scores the driver/vehicle with the worst driving behavior, based on events and their weights. Useful to identify risky behavior in the fleet.",
      DASHBOARD_CHARTS_MOST_ACTIVE_VEHICLES:
        "Indicators that point out the vehicles with the highest circulation (vehicle on and moving). Useful metric to balance fleet usage and increase operational efficiency.",
      DASHBOARD_CHARTS_MOST_IDLE_VEHICLES:
        "Provides metrics about vehicles with the highest idleness (on but not moving). Useful for reducing operating costs, increasing efficiency, and planning maintenance.",
      DASHBOARD_CHARTS_OUTSIDE_HOURS_USAGE:
        "Indicates the use of vehicles outside the hours defined by the company (in km). Useful to identify improper use or exceptional situations in operations.",
      DASHBOARD_CHARTS_WEEKLY_CIRCULATION:
        "Indicator showing the sum of fleet circulation by period (in km), broken down by day of the week (Monday to Sunday).",
      DASHBOARD_CHARTS_SPEED_LIMIT_EXCESS:
        "Shows how much vehicles are exceeding speed limits, either the company limit or the legal road limit. Useful for safety management.",

      // Main pages
      MINHA_FROTA:
        "Check the real-time status of all vehicles in your fleet with detailed information on location and operation. View on map or grid with filters by plate, group, status, ignition, speed, driver, and location.",
      POSICOES_DETALHADAS:
        "Track the detailed position of each vehicle with movement history from the start of the day. Allows applying filters for other periods and performing specific actions.",
      GRID_JOURNEY_WORK:
        "Analyze vehicle work journeys with information on routes, durations, and operational efficiency. View trip details from origin to destination.",
      GRID_SPEED_CONTROL:
        "Monitor speeding events and speed above the limit, generating safety reports. Filter by vehicle grouping, type of occurrence, and analysis period.",
      GRID_VISIT_AMOUNT:
        "Track visit and stop points with analysis of time spent at each location. Identify which vehicles made visits with start, end, and duration of each one.",
      GRID_PERIOD_VISITS:
        "View visits grouped by period with performance statistics and metrics. Filter by minimum stay time and specific period.",
      GRID_PROTOCOLS:
        "Check protocols and procedures registered for each operational event, including automatic protocols, event-based protocols, or support protocols.",
      APELIDO:
        "Allows the user to assign a vehicle name, such as a fleet code or description.",
      RADAR:
        "Map view that automatically updates with all active vehicles, filtered by groups and periods. Opens in a separate browser window.",
      VEICULO_MAIS_PROXIMO:
        "Geolocation feature that lets you search for the vehicle closest to an address, another vehicle, or a visit point. Includes distance and estimated arrival time.",
      CONTROL_POINT:
        "Manage control and access points, monitoring passes and associated events. Allows registering locations where vehicles make stops and visits.",
      ELETRONIC_FENCES:
        "Configure and monitor electronic fences (geofences) for entry and exit alerts. Used for security, fleet control, and logistics management.",
      RISK_AREA:
        "Identify risk areas based on historical events and driving behavior. The system signals when vehicles enter or leave the delimited area.",
      VEHICLES_CONFIGURATION:
        "Configure vehicle properties and parameters, business hours, speed limits, and other references.",
      DRIVERS_MANAGEMENT:
        "Manage driver data, documents, event history, and performance. Add complementary data and define driving permissions per vehicle.",
      USERS_GROUPS:
        "Organize users into groups for access control and permissions. The main user can create and manage limited access for other users.",
      VEHICLES_GROUPS:
        "Group vehicles by operational criteria for easier analysis and management. Configure specific parameters, generate automatic reports, and define references.",
      VEHICLE_DETAILS:
        "Detailed vehicle information including technical specifications, documentation, history, and location. View battery level, ignition status, speed, odometer, and street view.",
      DRIVER_DETAILS:
        "Complete driver data, including licenses, event history, and performance. Add complementary information and driving permissions.",
      REPORTS:
        "Generate custom reports with data on operation, safety, and fleet efficiency, including movement, positioning, distance traveled, visits, and speed control.",
      SETTINGS:
        "Configure system preferences, notifications, and operating parameters. Change business hours, speed limits, and other fleet settings.",
      USER_PROFILE:
        "Manage your user profile, updating personal data and preferences. Also allows changing the password and managing account information.",
      HELP:
        "Help center with documentation, tutorials, and technical support. Access information about all system features.",
      POINT_OF_VISIT:
        "Register places where vehicles make stops and visits (suppliers, customers, points of interest). Helps identify locations when the address is replaced by the point name.",
      USER_PROFILE_CLIENT:
        "Define user information such as personal data and access preferences.",
      COMPANY_INFO:
        "Display registered company information, allowing data consultation.",
      CHANGE_PASSWORD:
        "Change your user account password for greater security.",
      PROTOCOLS:
        "Screen that allows consultation of generated protocols, whether automatic, event-based, or service-based.",
      LOGS:
        "Activity log screen that allows consulting all actions performed by the user in the Movyx Safe system.",
      GROUPS:
        "Screen to create, edit, and manage vehicle groups and their specific configuration, enabling automatic reports and configuration of parameters and references for reports and dashboards.",
      BIND_VEHICLES:
        "Allows assigning a vehicle to a group, and also reassigning vehicles from one group to another.",
      GROUP_USERS:
        "Manages user permissions (created within the customer account) to view and manage specific groups.",
      POSITION:
        "Function that allows accessing the vehicle positioning history for a specified period.",
      DISTANCE:
        "Query that determines the total distance traveled by a vehicle in a specific time interval, recording start and end points including their respective locations.",
      MAINTENANCE_ITEM: "Screen used to register and manage maintenance items, allowing users to create, edit, deactivate, and view all components that are part of the services",
      MAINTENANCE_SCHEDULING: "Screen intended for scheduling maintenance, where the user defines dates, vehicles or equipment, responsible persons, and the periodicity of the interventions that need to be carried out",
      MAINTENANCE_SHIPPING: "Screen focused on controlling the shipment and receipt of parts or equipment for external maintenance, recording shipments, carriers, deadlines, and the logistical status of each item",
      MAINTENANCE_REGISTER: "Screen responsible for the detailed registration of maintenance performed, including service description, parts used, hours worked, costs, and the technician responsible for execution",
      MAINTENANCE_PENDING: "Screen that lists all pending maintenance tasks, allowing users to filter, prioritize, and track activities that still need to be performed, approved, or scheduled in the maintenance workflow",
      MAINTENANCE_COMPLETED: "Screen that shows the history of completed maintenance, making it easier to perform queries, audits, and generate reports on performance, costs, and the history of equipment or vehicles",
    },
  },
};
